import { useTranslation } from 'react-i18next'

import { Modal } from './modal'

interface ConfirmDialogProps {
  open: boolean
  title: string
  body: string
  confirmLabel: string
  busyLabel?: string
  busy?: boolean
  danger?: boolean
  errorKey?: string | null
  onConfirm: () => void
  onClose: () => void
}

/**
 * Explicit confirmation for destructive or relationship-changing actions
 * (block, remove friend, account deletion, request decisions).
 */
export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  busyLabel,
  busy = false,
  danger = false,
  errorKey = null,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      title={title}
      onClose={onClose}
      closeDisabled={busy}
      footer={
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            className="btn-secondary min-h-11 px-4 text-sm"
            disabled={busy}
            onClick={onClose}
          >
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className={`btn-primary min-h-11 px-4 text-sm ${
              danger ? 'bg-danger text-white hover:bg-danger' : ''
            }`}
            disabled={busy}
            aria-busy={busy}
            onClick={onConfirm}
          >
            {busy ? (busyLabel ?? t('common.loading')) : confirmLabel}
          </button>
        </div>
      }
    >
      <p className="text-[15px] leading-relaxed text-deep">{body}</p>
      {errorKey ? (
        <p role="alert" className="mt-3 text-sm font-semibold text-danger">
          {t(errorKey)}
        </p>
      ) : null}
    </Modal>
  )
}
